import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["trackingKey", "trackingNumber", "blNumber"];

  toggleTrackTraceForm(e) {
    const newValue = e.target.value;

    if (newValue == "portbase") {
      this.trackingKeyTarget.setAttribute("disabled", "true");
      this.trackingKeyTarget.value = "bl_number";
      this.trackingNumberTarget.setAttribute("readonly", "true");
      this.trackingNumberTarget.value = this.blNumberTarget.value;
    } else {
      this.trackingKeyTarget.removeAttribute("disabled", "true");
      this.trackingNumberTarget.removeAttribute("readonly", "true");
    }
  }
}
